import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetRunPartsDeliveryQueryVariables = Types.Exact<{
  runId: Types.Scalars['bigint']['input'];
}>;


export type GetRunPartsDeliveryQuery = { __typename?: 'query_root', mobility_runs_by_pk?: { __typename?: 'mobility_runs', id: number, parts_delivery?: { __typename?: 'parts_deliveries', id: number, orchestration_status: string, last_error?: object | null, vendor?: string | null, delivery_status: string, fee_cents?: number | null, currency?: string | null, tip_cents?: number | null, dropoff_eta?: string | null, dropoff_deadline?: string | null, driver?: object | null, proof_of_delivery?: object | null, tracking_url?: string | null, cancelation_reason?: string | null, booked_at?: string | null, completed_at?: string | null, created_by?: string | null } | null } | null };


export const GetRunPartsDeliveryDocument = gql`
    query getRunPartsDelivery($runId: bigint!) {
  mobility_runs_by_pk(id: $runId) {
    id
    parts_delivery {
      id
      orchestration_status
      last_error
      vendor
      delivery_status
      fee_cents
      currency
      tip_cents
      dropoff_eta
      dropoff_deadline
      driver
      proof_of_delivery
      tracking_url
      cancelation_reason
      booked_at
      completed_at
      created_by
    }
  }
}
    `;

/**
 * __useGetRunPartsDeliveryQuery__
 *
 * To run a query within a React component, call `useGetRunPartsDeliveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRunPartsDeliveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRunPartsDeliveryQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useGetRunPartsDeliveryQuery(baseOptions: Apollo.QueryHookOptions<GetRunPartsDeliveryQuery, GetRunPartsDeliveryQueryVariables> & ({ variables: GetRunPartsDeliveryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRunPartsDeliveryQuery, GetRunPartsDeliveryQueryVariables>(GetRunPartsDeliveryDocument, options);
      }
export function useGetRunPartsDeliveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRunPartsDeliveryQuery, GetRunPartsDeliveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRunPartsDeliveryQuery, GetRunPartsDeliveryQueryVariables>(GetRunPartsDeliveryDocument, options);
        }
// @ts-ignore
export function useGetRunPartsDeliverySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRunPartsDeliveryQuery, GetRunPartsDeliveryQueryVariables>): Apollo.UseSuspenseQueryResult<GetRunPartsDeliveryQuery, GetRunPartsDeliveryQueryVariables>;
export function useGetRunPartsDeliverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRunPartsDeliveryQuery, GetRunPartsDeliveryQueryVariables>): Apollo.UseSuspenseQueryResult<GetRunPartsDeliveryQuery | undefined, GetRunPartsDeliveryQueryVariables>;
export function useGetRunPartsDeliverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRunPartsDeliveryQuery, GetRunPartsDeliveryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRunPartsDeliveryQuery, GetRunPartsDeliveryQueryVariables>(GetRunPartsDeliveryDocument, options);
        }
export type GetRunPartsDeliveryQueryHookResult = ReturnType<typeof useGetRunPartsDeliveryQuery>;
export type GetRunPartsDeliveryLazyQueryHookResult = ReturnType<typeof useGetRunPartsDeliveryLazyQuery>;
export type GetRunPartsDeliverySuspenseQueryHookResult = ReturnType<typeof useGetRunPartsDeliverySuspenseQuery>;
export type GetRunPartsDeliveryQueryResult = Apollo.QueryResult<GetRunPartsDeliveryQuery, GetRunPartsDeliveryQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/getRunPartsDelivery.query.gql}
 */
export async function getRunPartsDelivery(
  variables: GetRunPartsDeliveryQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetRunPartsDeliveryQuery['mobility_runs_by_pk']>
export async function getRunPartsDelivery(
  variables: GetRunPartsDeliveryQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetRunPartsDeliveryQuery>
export async function getRunPartsDelivery(
  variables: GetRunPartsDeliveryQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetRunPartsDeliveryQuery['mobility_runs_by_pk'] | GetRunPartsDeliveryQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetRunPartsDeliveryQuery>(
    GetRunPartsDeliveryDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.mobility_runs_by_pk
}